<template>
  <EditarBase
    :itemAtual="itemAtual"
    :recursoInicial="recursoInicial"
    nomeSingular="Pedido"
    nomePlural="Pedidos"
    @recurso="atualizarRecurso"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-container id="user-profile" fluid tag="section">
      <v-row justify="center">
        <v-col cols="12" md="12">
          <v-form v-if="!submited" autocomplete="off">
            <v-row>
              <v-col cols="12" md="2" id="campo-dt-inicio">
                <span class="opacity-5 text-dark">
                  {{ $t("Data") }}
                </span>
                <CampoData
                  :payload="recurso.data"
                  @date="recurso.data = $event"
                  :label="$t('Data')"
                />
              </v-col>

              <v-col cols="12" md="2">
                <span class="opacity-5 text-dark">
                  {{ $t("Status") }}
                </span>
                <v-select
                  :items="[
                    { text: $t('Pendente'), value: 'PENDENTE' },
                    { text: $t('Roteirizado'), value: 'ROTEIRIZADO' },
                    { text: $t('Cancelado'), value: 'CANCELADO' },
                  ]"
                  v-model="recurso.statusPedido"
                  :label="$t('Status')"
                  disabled
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <span class="opacity-5 text-dark">
                  {{ $t("Classificacao") }}
                </span>
                <v-select
                  :items="[
                    { text: $t('ROTINEIRO'), value: 'ROTINEIRO' },
                    { text: $t('EVENTUAL'), value: 'EVENTUAL' },
                    { text: $t('ESPECIAL'), value: 'ESPECIAL' },
                    { text: $t('ASSISTENCIA'), value: 'ASSISTENCIA' },
                  ]"
                  v-model="recurso.classificacao"
                  :label="$t('Classificacao')"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <span class="opacity-5 text-dark">
                  {{ $t("Cliente") }}
                </span>
              </v-col>
              <v-col cols="12" md="12">
                <CampoRelacionamentoCadastroRapido
                  v-model="recurso.cliente"
                  :items="clientes"
                  url="clientes"
                  cadastro-url="cadastro.Cliente"
                  :item-text="
                    (item) => item.fantasia + ' - ' + item.razaoSocial
                  "
                  label="Cliente"
                  @submitSuccessInsert="getClientes"
                />
              </v-col>
              <v-col cols="12" md="12">
                <span class="opacity-5 text-dark">
                  {{ $t("Origem") }}
                </span>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  outlined
                  v-model="clienteOrigem"
                  :items="clientes"
                  item-text="fantasia"
                  label="Cliente"
                  return-object
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  disabled
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="5">
                <v-autocomplete
                  outlined
                  :label="$t('Endereco')"
                  v-model="recurso.origem"
                  :items="clienteOrigem.enderecos"
                  :item-text="
                    (item) =>
                      item.descricao +
                      ' - ' +
                      item.logradouro +
                      ', ' +
                      item.numero +
                      ', ' +
                      item.bairro +
                      ' - ' +
                      ((item.cidade && item.cidade.nome) || '') +
                      (item.cidade &&
                      item.cidade.estado &&
                      item.cidade.estado.sigla
                        ? '/' + item.cidade.estado.sigla
                        : '')
                  "
                  return-object
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  disabled
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="2">
                <CampoDataHora
                  @date="recurso.janelaOrigemInicio = $event"
                  name="janelaOrigemInicio"
                  :label="$t('janelaOrigemInicio')"
                  :payload="recurso.janelaOrigemInicio"
                />
              </v-col>
              <v-col cols="12" md="2">
                <CampoDataHora
                  @date="recurso.janelaOrigemFinal = $event"
                  name="janelaOrigemFinal"
                  :label="$t('janelaOrigemFinal')"
                  :payload="recurso.janelaOrigemFinal"
                />
              </v-col>

              <v-col
                cols="12"
                md="12"
                v-if="recurso.classificacao !== 'ASSISTENCIA'"
              >
                <span class="opacity-5 text-dark">
                  {{ $t("Destino") }}
                </span>
              </v-col>
              <v-col
                cols="12"
                md="3"
                v-if="recurso.classificacao !== 'ASSISTENCIA'"
              >
                <v-autocomplete
                  outlined
                  v-model="clienteDestino"
                  :items="clientes"
                  item-text="fantasia"
                  label="Destino"
                  return-object
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  disabled
                >
                </v-autocomplete>
              </v-col>

              <v-col
                cols="12"
                md="5"
                v-if="recurso.classificacao !== 'ASSISTENCIA'"
              >
                <v-autocomplete
                  outlined
                  :label="$t('Endereco')"
                  v-model="recurso.destino"
                  :items="clienteDestino.enderecos"
                  :item-text="
                    (item) =>
                      item.descricao +
                      ' - ' +
                      item.logradouro +
                      ', ' +
                      item.numero +
                      ', ' +
                      item.bairro +
                      ' - ' +
                      ((item.cidade && item.cidade.nome) || '') +
                      (item.cidade &&
                      item.cidade.estado &&
                      item.cidade.estado.sigla
                        ? '/' + item.cidade.estado.sigla
                        : '')
                  "
                  return-object
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  disabled
                >
                </v-autocomplete>
              </v-col>

              <v-col
                cols="12"
                md="2"
                v-if="recurso.classificacao !== 'ASSISTENCIA'"
              >
                <CampoDataHora
                  @date="recurso.janelaDestinoInicio = $event"
                  name="janelaDestinoInicio"
                  :label="$t('janelaDestinoInicio')"
                  :payload="recurso.janelaDestinoInicio"
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                v-if="recurso.classificacao !== 'ASSISTENCIA'"
              >
                <CampoDataHora
                  @date="recurso.janelaDestinoFinal = $event"
                  name="janelaDestinoFinal"
                  :label="$t('janelaDestinoFinal')"
                  :payload="recurso.janelaDestinoFinal"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <span class="opacity-5 text-dark">
                  {{ $t("Averbacao") }}
                </span>
                <v-text-field
                  v-model="recurso.averbacao"
                  :label="$t('Averbacao')"
                  name="averbacao"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <span class="opacity-5 text-dark">
                  {{ $t("SolicitacaoCliente") }}
                </span>
                <v-text-field
                  v-model="recurso.solicitacaoCliente"
                  :label="$t('SolicitacaoCliente')"
                  name="solicitacaoCliente"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <CriaSuperSet
                  :podeEditarRecursoFinal="true"
                  @recursos="recurso.itemsLogistica = $event"
                  :payload="recurso.itemsLogistica"
                  :usaRecursoBase="false"
                  tituloFinais="ItensLogistica"
                  subtituloFinais="Clique_para_adicionar"
                  :headersFinais="[
                    {
                      text: this.$t('Nota'),
                      value: 'documentoNumero',
                      sortable: 'false',
                    },
                    {
                      text: this.$t('OrdemCarga'),
                      value: 'ordemCarga',
                      sortable: 'false',
                    },
                    {
                      text: this.$t('Valor'),
                      value: 'valor',
                      sortable: 'false',
                    },
                    {
                      text: this.$t('Identificador'),
                      value: 'identificador',
                      sortable: 'false',
                    },

                    {
                      text: this.$t('Acoes'),
                      value: 'actions',
                      sortable: 'false',
                    },
                  ]"
                  textoBotaoCadastro="Criar_item"
                >
                  <template v-slot:default="slotProps">
                    <!-- Form cria recurso final -->
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.documentoNumero"
                        :label="$t('numeroDocumento')"
                        name="documentoNumero"
                        :rules="rule_required"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.documentoSerie"
                        :label="$t('serieDocumento')"
                        name="documentoSerie"
                        :rules="documentoSerie"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.ordemCarga"
                        :label="$t('OrdemCarga')"
                        name="ordemCarga"
                        :rules="ordemCarga"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.volumes"
                        :label="$t('Volumes')"
                        name="volumes"
                        :rules="rule_required"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field-money
                        v-model="slotProps.recursoFinalAtual.m3"
                        v-bind:label="$t('M3')"
                        v-bind:properties="{
                          prefix: '',
                          readonly: false,
                          disabled: false,
                          outlined: false,
                          clearable: true,
                          rules: required,
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '0',
                        }"
                        class="
                          font-size-input
                          text-light-input
                          placeholder-light
                        "
                        dense
                        flat
                        filled
                        solo
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field-money
                        v-model="slotProps.recursoFinalAtual.peso"
                        v-bind:label="$t('PesoKg')"
                        v-bind:properties="{
                          prefix: '',
                          readonly: false,
                          disabled: false,
                          outlined: false,
                          clearable: true,
                          rules: required,
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '0',
                        }"
                        class="
                          font-size-input
                          text-light-input
                          placeholder-light
                        "
                        dense
                        flat
                        filled
                        solo
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field-money
                        v-model="slotProps.recursoFinalAtual.valor"
                        v-bind:label="$t('Valor')"
                        v-bind:properties="{
                          prefix: 'R$',
                          readonly: false,
                          disabled: false,
                          outlined: false,
                          clearable: true,
                          rules: required,
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '0',
                        }"
                        class="
                          font-size-input
                          text-light-input
                          placeholder-light
                        "
                        dense
                        flat
                        filled
                        solo
                      />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.chaveNfe"
                        :label="$t('ChaveNfe')"
                        name="chaveNfe"
                        :rules="chaveNfe"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.chaveCte"
                        :label="$t('ChaveCte')"
                        name="chaveCte"
                        :rules="chaveCte"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.identificador"
                        :label="$t('Identificador')"
                        name="identificador"
                        :rules="identificador"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                  </template>
                  <template v-slot:formEditaRecursoFinal="slotProps">
                    <!-- Form cria recurso final -->
                    <v-col cols="12" md="4">
                      <span class="opacity-5 text-dark">
                        {{ $t("numeroDocumento") }}
                      </span>
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.documentoNumero"
                        :label="$t('numeroDocumento')"
                        name="documentoNumero"
                        :rules="rule_required"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <span class="opacity-5 text-dark">
                        {{ $t("serieDocumento") }}
                      </span>
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.documentoSerie"
                        :label="$t('serieDocumento')"
                        name="documentoSerie"
                        :rules="documentoSerie"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="5">
                      <span class="opacity-5 text-dark">
                        {{ $t("OrdemCarga") }}
                      </span>
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.ordemCarga"
                        :label="$t('OrdemCarga')"
                        name="ordemCarga"
                        :rules="ordemCarga"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <span class="opacity-5 text-dark">
                        {{ $t("Volumes") }}
                      </span>
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.volumes"
                        :label="$t('Volumes')"
                        name="volumes"
                        :rules="rule_required"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                        type="number"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field-money
                        v-model="slotProps.recursoFinalAtual.m3"
                        v-bind:label="$t('M3')"
                        v-bind:properties="{
                          prefix: '',
                          readonly: false,
                          disabled: false,
                          outlined: false,
                          clearable: true,
                          rules: required,
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '0',
                        }"
                        class="
                          font-size-input
                          text-light-input
                          placeholder-light
                        "
                        dense
                        flat
                        filled
                        solo
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field-money
                        v-model="slotProps.recursoFinalAtual.peso"
                        v-bind:label="$t('PesoKg')"
                        v-bind:properties="{
                          prefix: '',
                          readonly: false,
                          disabled: false,
                          outlined: false,
                          clearable: true,
                          rules: required,
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '0',
                        }"
                        class="
                          font-size-input
                          text-light-input
                          placeholder-light
                        "
                        dense
                        flat
                        filled
                        solo
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field-money
                        v-model="slotProps.recursoFinalAtual.valor"
                        v-bind:label="$t('Valor')"
                        v-bind:properties="{
                          prefix: 'R$',
                          readonly: false,
                          disabled: false,
                          outlined: false,
                          clearable: true,
                          rules: required,
                        }"
                        v-bind:options="{
                          locale: 'pt-BR',
                          length: 12,
                          precision: 2,
                          empty: '0',
                        }"
                        class="
                          font-size-input
                          text-light-input
                          placeholder-light
                        "
                        dense
                        flat
                        filled
                        solo
                      />
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="opacity-5 text-dark">
                        {{ $t("ChaveNfe") }}
                      </span>
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.chaveNfe"
                        :label="$t('ChaveNfe')"
                        name="chaveNfe"
                        :rules="chaveNfe"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="opacity-5 text-dark">
                        {{ $t("ChaveCte") }}
                      </span>
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.chaveCte"
                        :label="$t('ChaveCte')"
                        name="chaveCte"
                        :rules="chaveCte"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <span class="opacity-5 text-dark">
                        {{ $t("Identificador") }}
                      </span>
                      <v-text-field
                        v-model="slotProps.recursoFinalAtual.identificador"
                        :label="$t('Identificador')"
                        name="identificador"
                        :rules="identificador"
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                  </template>
                </CriaSuperSet>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" v-if="recurso.classificacao !== 'ASSISTENCIA'">
                <ComposicaoPedido
                  v-model="recurso.composicao"
                  :moedas="moedasAtivas"
                  :pais-inquilino-id="paisInquilinoId"
                  :codigo-moeda="codigoMoeda"
                  :erro-catalogo="erroMoedas"
                  :carregando-moedas="carregandoMoedas"
                />
              </v-col>

              <v-col
                cols="12"
                md="12"
                v-if="recurso.classificacao === 'ASSISTENCIA'"
              >
                <div>
                  <div>
                    <h5 class="font-weight-bold text-h5 text-typo mb-0">
                      {{ $t("Listagem_tipos") }}
                    </h5>
                    <p class="text-sm text-body mb-0">
                      {{ $t("Clique_para_adicionar") }}
                    </p>
                  </div>
                  <div class="d-flex align-center">
                    <v-col cols="12" md="5">
                      <v-text-field
                        hide-details
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                        height="39"
                        v-model="search"
                        :label="$t('Procurar')"
                      >
                        <template slot="prepend-inner">
                          <v-icon color="#adb5bd" size=".875rem"
                            >fas fa-search</v-icon
                          >
                        </template></v-text-field
                      >
                    </v-col>
                  </div>

                  <v-data-table
                    :headers="headersAssistenciaTipos"
                    :items="assistenciaTipos"
                    :search="search"
                    @click:row="handleClickTipoAssistencia"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small class="mr-2" @click="editCliente(item.id)"
                        >ni-ruler-pencil</v-icon
                      >
                      <v-icon small @click="confirmaExclusao(item)"
                        >ni-fat-remove</v-icon
                      >
                    </template>
                  </v-data-table>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="12"
                v-if="recurso.classificacao === 'ASSISTENCIA'"
              >
                <div>
                  <div class="card-header-padding">
                    <div>
                      <h5 class="font-weight-bold text-h5 text-typo mb-0">
                        {{ $t("Listagem_tipos") }}
                      </h5>
                    </div>
                    <div class="d-flex align-center">
                      <v-col cols="12" md="5">
                        <v-text-field
                          hide-details
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            input-icon
                          "
                          dense
                          flat
                          filled
                          solo
                          height="39"
                          v-model="searchPedido"
                          :label="$t('Procurar')"
                        >
                          <template slot="prepend-inner">
                            <v-icon color="#adb5bd" size=".875rem"
                              >fas fa-search</v-icon
                            >
                          </template></v-text-field
                        >
                      </v-col>
                    </div>
                  </div>

                  <v-data-table
                    :headers="headersItemsAssistenciaTipos"
                    :items="recurso.assistenciaTecnicaTipo"
                    :search="searchPedido"
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small @click="removeTipoAssistenciaTecnica(item)"
                        >ni-fat-remove</v-icon
                      >
                    </template>
                  </v-data-table>
                  <v-card-actions>
                    <!-- Total: R$ {{ this.valorSuprimento }} -->
                  </v-card-actions>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import ComposicaoPedido from "./ComposicaoPedido.vue";
import CampoRelacionamentoCadastroRapido from "@/components/base/proprios/CampoRelacionamentoCadastroRapido";

import CriaSuperSet from "@/components/base/proprios/CriaSuperset.vue";
import ClienteDataService from "@/services/comercial/ClienteDataService";
import AssistenciaTecnicaTipoDataService from "@/services/operacoes/AssistenciaTecnicaTipoDataService";
import OperacaoMoedaDataService from "@/services/operacoes/tesouraria/OperacaoMoedaDataService";
import PedidoDataService from "@/services/operacoes/PedidoDataService";
const DataService = PedidoDataService;

export default {
  props: {
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
  },
  name: "EditarPedido",
  components: {
    EditarBase,
    CriaSuperSet,
    CampoRelacionamentoCadastroRapido,
    ComposicaoPedido,
  },
  data() {
    return {
      DataService: DataService,

      submited: false,
      recurso: {
        ...(this.recursoInicial || this.itemAtual || {}),
        assistenciaTecnicaTipo:
          (this.recursoInicial || this.itemAtual || {})
            .assistenciaTecnicaTipo || [],
      },
      clienteOrigem: {
        enderecos: [],
      },
      clienteDestino: {
        enderecos: [],
      },
      pedido: [],
      search: "",
      clientes: [],
      cliente: {},
      todosPerfisDescricao: [],
      perfisSelecionados: [],
      todosPerfis: [],
      errors: [],
      assistenciaTecnicaTipo: [],
      tipoAssistenciaTecnica: {},
      moedasAtivas: [],
      paisInquilinoId: null,
      codigoMoeda: "BRL",
      erroMoedas: false,
      carregandoMoedas: true,
      assistenciaTipos: [],
      headersAssistenciaTipos: [
        {
          text: this.$t("Codigo"),
          value: "codigo",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("Descricao"),
          value: "descricao",
          align: "start",
          sortable: "false",
        },
        // { text: this.$t("Valor"), value: "valor", sortable: "true" },
        //{ text: this.$t("Estoque"), value: "estoque", sortable: "true" },
        // { text: this.$t("Status"), value: "statusComum", sortable: "false" },
      ],
      headersItemsAssistenciaTipos: [
        {
          text: this.$t("Codigo"),
          value: "codigo",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("Descricao"),
          value: "descricao",
          align: "start",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
  methods: {
    atualizarRecurso(recurso) {
      this.recurso = {
        ...recurso,
        composicao: (recurso.composicao || []).map((item) => ({
          ...item,
          operacaoMoedaId:
            item.operacaoMoedaId || item.operacaoMoeda?.id || null,
        })),
      };
    },
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },

    getClientes() {
      return ClienteDataService.getAll().then((res) => {
        this.clientes = res.data;

        const clienteSelecionadoId = this.recurso?.cliente?.id;
        if (clienteSelecionadoId) {
          const clienteSelecionado = this.clientes.find(
            (item) => String(item.id) === String(clienteSelecionadoId)
          );
          if (clienteSelecionado) {
            this.$set(this.recurso, "cliente", clienteSelecionado);
          }
        }

        let clienteEnderecoOrigem = this.recurso.origem;

        if (clienteEnderecoOrigem) {
          this.clienteOrigem = this.clientes.find((item) => {
            return item.enderecos.find(
              (end) => end.id === clienteEnderecoOrigem.id
            );
          });
        }

        let clienteEnderecoDestino = this.recurso.destino;

        if (clienteEnderecoDestino) {
          this.clienteDestino = this.clientes.find((item) => {
            return item.enderecos.find(
              (end) => end.id === clienteEnderecoDestino.id
            );
          });
        }
      });
    },
    getAssitenciaTecnicaTipos() {
      AssistenciaTecnicaTipoDataService.getActive().then((response) => {
        this.assistenciaTipos = response.data;
      });
    },

    async getOperacaoMoedas() {
      try {
        const response = await OperacaoMoedaDataService.catalogoRecontagem();
        this.moedasAtivas = response.data.moedas || [];
        this.paisInquilinoId = response.data.paisInquilinoId;
        this.codigoMoeda = response.data.moedaInquilinoCodigo || "BRL";
        this.erroMoedas = false;
      } catch (error) {
        this.erroMoedas = true;
      } finally {
        this.carregandoMoedas = false;
      }
    },
    getPedido() {
      DataService.find(this.recurso.id)
        .then((response) => {
          this.recurso.data = response.data.data;
          this.recurso.statusPedido = response.data.statusPedido;
          this.recurso.id = response.data.id;
          this.pedido = response.data.itens;
          console.log(response.data);
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
          this.errors.push({ field: "ID", message: "Pedido não encontrado" });
        });
    },
    getItemClass: function (item) {
      if (item.statusPedido === 1) {
        return "PENDENTE";
      }

      if (item.statusPedido === 2) {
        return "ROTEIRIZADO";
      }

      if (item.statusPedido === 3) {
        return "CANCELADO";
      }
    },
    handleClickTipoAssistencia(event) {
      this.tipoAssistenciaTecnica = event;
      this.addTipoAssistencia();
    },
    addTipoAssistencia() {
      console.log("item", this.tipoAssistenciaTecnica);
      console.log("items", this.recurso.assistenciaTecnicaTipo);
      if (this.recurso.assistenciaTecnicaTipo === undefined) {
        this.recurso.assistenciaTecnicaTipo = [{}];
      }

      var produtoExistente = this.recurso.assistenciaTecnicaTipo.find(
        (produto) => produto.id == this.tipoAssistenciaTecnica.id
      );

      if (
        !produtoExistente &&
        this.tipoAssistenciaTecnica.id !== undefined &&
        this.tipoAssistenciaTecnica.id > 0
      ) {
        this.recurso.assistenciaTecnicaTipo.push(this.tipoAssistenciaTecnica);
      }
      this.tipoAssistenciaTecnica = {};
    },

    removeTipoAssistenciaTecnica(event) {
      this.tipoAssistenciaTecnica = event;
      this.recurso.assistenciaTecnicaTipo =
        this.recurso.assistenciaTecnicaTipo.filter((produto) => {
          return produto.id !== this.tipoAssistenciaTecnica.id;
        });
      //this.$swal.fire(this.$t("Removido_com_sucesso"), "", "success");
    },
    verificaTipoAssistencia() {
      // Inicializa recurso.assistenciaTecnicaTipo se não existir
      if (!this.recurso.assistenciaTecnicaTipo) {
        this.$set(this.recurso, "assistenciaTecnicaTipo", []);
      }

      // Verifica se assistenciaTecnicaTipos está presente no recurso
      if (
        this.recurso.assistenciaTecnicaTipos &&
        this.recurso.assistenciaTecnicaTipos.length > 0
      ) {
        // Converte assistenciaTecnicaTipos para o formato necessário
        this.recurso.assistenciaTecnicaTipo =
          this.recurso.assistenciaTecnicaTipos.map((item) => ({
            id: item.assistenciaTecnicaTipo.id,
            descricao: item.assistenciaTecnicaTipo.descricao,
            codigo: item.assistenciaTecnicaTipo.codigo,
          }));
      }
    },
  },

  mounted() {
    if (!this.recurso.assistenciaTecnicaTipo) {
      this.$set(this.recurso, "assistenciaTecnicaTipo", []);
    }
    this.getClientes();
    // this.getPedido();
    this.getOperacaoMoedas();
    this.getAssitenciaTecnicaTipos();
    this.verificaTipoAssistencia();
  },

  computed: {
    agora: function () {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate().toString().padStart(2, "0");

      return date + "T00:00";
    },
  },
  watch: {},
};
</script>

<style scoped>
#data {
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 99px;
}

.mdl-textfield:not(.is-dirty) input::-webkit-datetime-edit {
  color: transparent;
}

input:focus::-webkit-datetime-edit {
  color: rgba(255, 255, 255, 0.46) !important;
}
</style>
